import { useCallback } from "react";
import { useFileExplorerSearchParams } from "./useFileExplorerSearchParams";
import type {
  FileExplorerFilters,
  FileExplorerSearchParams,
} from "../../types";
import type { CategoryAttributeResponse } from "@/services/api";
import { normalizeFilterValue } from "../../utils/fileUtils";

interface UseFileExplorerFiltersOptions {
  categoryAttributes: CategoryAttributeResponse[];
}

export function useFileExplorerFilters({
  categoryAttributes,
}: UseFileExplorerFiltersOptions) {
  const { updateSearchParams } = useFileExplorerSearchParams();

  const handleFiltersChange = useCallback(
    (newFilters: FileExplorerFilters) => {
      const searchParams: Partial<FileExplorerSearchParams> = {
        tags:
          newFilters.tags.length > 0 ? newFilters.tags.join(",") : undefined,
        name: normalizeFilterValue(newFilters.name),
      };

      categoryAttributes.forEach((attr) => {
        const attrName = attr.name;
        const filterValue = normalizeFilterValue(newFilters[attrName]);
        searchParams[attrName] = filterValue;
      });

      updateSearchParams(searchParams);
    },
    [updateSearchParams, categoryAttributes]
  );

  return {
    handleFiltersChange,
  };
}
